// File: src/components/404/NotFound404.js
// Purpose: Custom 404 page with Lottie animation
// Last modified: 2025-11-16

import './notFound404.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import { Player } from '@lottiefiles/react-lottie-player';
import { Container, Box, Button, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import MobileNavigation from '../BottomNavigation';

const NotFound404 = () => {
    return (
        <div className="not-found-container">
            <Container maxWidth="md">
                <Box className="not-found-content">
                    {/* Lottie Animation */}
                    <div className="animation-container">
                        <Player
                            autoplay
                            loop
                            src="https://assets1.lottiefiles.com/packages/lf20_kcsr6fcp.json"
                            style={{ height: '300px', width: '300px' }}
                        />
                    </div>

                    {/* Error Message */}
                    <Typography variant="h4" component="h1" className="error-title">
                        404 - Sahifa Topilmadi
                    </Typography>

                    <Typography variant="body1" className="error-description">
                        Kechirasiz, siz qidirgan sahifa mavjud emas yoki o'chirilgan bo'lishi mumkin.
                    </Typography>

                    {/* Action Buttons */}
                    <Box className="action-buttons">
                        <Button
                            variant="contained"
                            component={Link}
                            to="/"
                            startIcon={<HomeIcon />}
                            className="home-button"
                        >
                            Bosh Sahifaga Qaytish
                        </Button>

                        <Button
                            variant="outlined"
                            onClick={() => window.history.back()}
                            className="back-button"
                        >
                            Orqaga Qaytish
                        </Button>
                    </Box>

                    {/* Additional Help */}
                    <Box className="help-section">
                        <Typography variant="body2" className="help-text">
                            Agar bu xatolik davom etsa, iltimos biz bilan bog'laning.
                        </Typography>
                        <Link to="/sozlanmalar" className="contact-link">
                            Bog'lanish
                        </Link>
                    </Box>
                </Box>
            </Container>
            <MobileNavigation />
        </div>
    );
};

export default NotFound404;
